import {useEffect, useState} from "react";
import GoldMedal from "images/IPX/Runnerz/ipx_runnerz_icon_medal_01.png";
import SilverMedal from "images/IPX/Runnerz/ipx_runnerz_icon_medal_02.png";
import CopperMedal from "images/IPX/Runnerz/ipx_runnerz_icon_medal_03.png";
import View from "./View";

export default function Container({self = false, ranking, ci, record, name}) {
  const [medalImg, setMedalImg] = useState(GoldMedal);

  useEffect(() => {
    if (ranking <= 3) {
      switch (ranking) {
        case 1:
          setMedalImg(GoldMedal);
          break;
        case 2:
          setMedalImg(SilverMedal);
          break;
        case 3:
          setMedalImg(CopperMedal);
          break;
        default:
          break;
      }
    }
  }, [ranking]);

  return (
    <View
      self={self}
      ranking={ranking}
      record={record}
      medalImg={medalImg}
      name={name}
    />
  );
}
